export const boardAppearanceEn = {
  title: 'Board background',
  checkboxBg: 'Select the background of this board for all users',
  uploadCustomBg: 'Upload custom background',
  backToSaved: 'Return to saved',
  emptyResults: 'Nothing found',
  unsplashErrorRequestLimit:
    'Exceeded request limit per user (20 requests per hour)',
  unsplashCommonError: 'Cannot get photo from unsplash',
  noAccess: 'No access',
  photos: 'Photos',
  theme: 'Photos color',
  themeNotDefined: 'Not set',
  themeBlackWhite: 'Black and white',
  themeBlack: 'Black',
  themeWhite: 'White',
  themeRed: 'Red',
  themeOrange: 'Orange',
  themeYellow: 'Yellow',
  themeGreen: 'Green',
  themePurple: 'Purple',
  themeBlue: 'Blue',
  themeMagenta: 'Magenta',
  themeTeal: 'Teal',
  searchExamples: 'Search examples',
  confirmAreYouSureChangeBg:
    'Are you sure you want to change the background of this board for all users?'
}

export const boardAppearanceRu: typeof boardAppearanceEn = {
  title: 'Фон доски',
  checkboxBg: 'Выбрать фон этой доски для всех пользователей',
  uploadCustomBg: 'Загрузить свой фон',
  backToSaved: 'Вернуться к сохраненным',
  emptyResults: 'Ничего не найдено',
  unsplashErrorRequestLimit:
    'Превышен лимит запросов на пользователя (20 запросов в час)',
  unsplashCommonError: 'Не получается получить фото с unsplash',
  noAccess: 'Нет доступа',
  photos: 'Фотографии',
  theme: 'Цвет фото',
  themeNotDefined: 'Не задано',
  themeBlackWhite: 'Черно-белый',
  themeBlack: 'Черный',
  themeWhite: 'Белый',
  themeRed: 'Красный',
  themeOrange: 'Оранжевый',
  themeYellow: 'Желтый',
  themeGreen: 'Зеленый',
  themeBlue: 'Синий',
  themeMagenta: 'Пурпурный',
  themePurple: 'Фиолетовый',
  themeTeal: 'Бирюзовый',
  searchExamples: 'Примеры поиска',
  confirmAreYouSureChangeBg:
    'Вы действительно хотите сменить фон этой доски для всех пользователей?'
}
